import React from 'react';
import { TakeOffPreflightProps } from './types';
import { ArcCheckbox, ArcStack, ArcText } from '@src/core/ui';
import { safeDistanceLabel } from '@src/core/extensions';
import { useUnitType } from '@src/core/features/settings';


const TakeOffPreflight: React.FC<TakeOffPreflightProps> = (props) => {
  const { isAgree, toggleAgree, sx } = props;
  // Subscribe so the clearance label re-renders on a live unit switch (UNITS Standard R1/R5).
  useUnitType();

  return (
    <ArcStack spacing={1} sx={sx}>
      <ArcStack paddingBottom={1}>
        <ArcText.h5 fontWeight={500}> CHECKLIST</ArcText.h5>
      </ArcStack>
      <ArcStack p={2} spacing={1} borderRadius={1} bgcolor='background.paper'>
        <ArcText.caption color='text.primary' fontSize={12}>
          1. Payload is loaded  
        </ArcText.caption>
        <ArcText.caption color='text.primary' fontSize={12}>
          2. Payload is secured  
        </ArcText.caption>
        <ArcText.caption color='text.primary' fontSize={12}>
          3. Flight is authorized  
        </ArcText.caption>
        <ArcText.caption color='text.primary' fontSize={12}>
          4. Propellers are secure    
        </ArcText.caption>
        <ArcText.caption color='text.primary' fontSize={12}>
          5. Nothing is obstructing the drone’s path within {safeDistanceLabel()} radius area
        </ArcText.caption>
        <ArcText.caption color='text.primary' fontSize={12}>
          6. Stand at least {safeDistanceLabel()} away from the drone
        </ArcText.caption>
      </ArcStack>
      <ArcStack direction='row' alignItems='center'>
        <ArcCheckbox
          size='small'  
          color='brand' 
          title='Agree and confirm all items in checklist' 
          checked={isAgree} 
          onChange={() => toggleAgree()} />
        <ArcText.caption> Agree and confirm all items in checklist </ArcText.caption>
      </ArcStack>
    </ArcStack>

  );
};

export default TakeOffPreflight;